// extracted by mini-css-extract-plugin
module.exports = {"footer":"index-module--footer--329-w","copyright":"index-module--copyright--2q_rg","nav":"index-module--nav--23jjQ"};